import React from 'react'
import { Link as RouterLink } from 'react-router'
import { FaAndroid, FaApple } from 'react-icons/fa'
import { Box, Stack, Heading, Text, Alert, Button, ReadOnlyCopyInput } from '@/components/lib'
import utils from '../../utils/utils'
import useStore from '../../store'

export default function ParticipantJoinInfo ({ trial }) {
  const { user } = useStore()

  const consentUrl = `https://app.trialflare.com/consent/${trial?.code}`
  return (
    <Stack gap={3}>
      <Text>When you are happy to do so, you can get participants to join the trial directly.</Text>
      {trial?.eConsentEnabled &&
        <Alert variant='left-accent' mt={3}>
          <Box>
            <Heading size='sm'>eConsent is enabled for this trial</Heading>
            <Text fontSize='xs'>Participants must eConsent before they can take part in the trial. Participants can eConsent at the URL shown below.</Text>
            <ReadOnlyCopyInput value={consentUrl} size='xs' />
          </Box>
        </Alert>}

      <Stack direction='row' alignItems='center'>
        <Box w={50} textAlign='center'>
          <Text fontSize={40} color='primary.fg'>1</Text>
        </Box>
        <Box ml={5} flex='1'>
          <Heading size='sm'>Tell participants where to go</Heading>
          <Text>Give participants the trial URL or ask them to download the official Trialflare app.</Text>
          <Heading as='h4' size='sm' fontWeight='semiBold' mt={5} mb={3}>Using the official app (search "Trialflare" in your app store)</Heading>
          <Button colorPalette='blue' mr={2} mb={2} size='sm' as='a' href='https://play.google.com/store/apps/details?id=app.trilo' target='_blank' icon='android'><Box as={FaAndroid} mr={2} /> Android app</Button>
          <Button colorPalette='blue' mb={2} size='sm' as='a' href='https://itunes.apple.com/gb/app/trilo/id1460738681' target='_blank' icon='apple'><Box as={FaApple} mr={2} /> iPhone &amp; iPad app</Button>
          <Heading as='h4' size='sm' fontWeight='semiBold' mt={5} mb={3}>Using the participant web portal</Heading>
          <ReadOnlyCopyInput value='https://join.trialflare.com' size='xs' />
        </Box>
      </Stack>

      <Stack direction='row' alignItems='center'>
        <Box w={50} textAlign='center'>
          <Text fontSize={40} color='primary.fg'>2</Text>
        </Box>
        <Box ml={5} flex='1'>
          <Heading size='sm'>Share the trial code</Heading>
          <Text mb={3}>Participants use this code to access the trial using the website or app.</Text>
          {trial.code
            ? (
              <ReadOnlyCopyInput value={trial.code} size='xs' />)
            : <Alert status='warning' variant='left-accent'>No code has been set yet.</Alert>}
          {utils.canManageTrial(user, trial) &&
            <Button mt={3} as={RouterLink} to={`/trials/${trial._id}/info`} size='sm' colorPalette='blue' variant='outline'>Edit trial code</Button>}
        </Box>
      </Stack>

      <Stack direction='row' alignItems='center'>
        <Box w={50} textAlign='center'>
          <Text fontSize={40} color='primary.fg'>3</Text>
        </Box>
        <Box ml={5} flex='1'>
          <Heading size='sm'>Participant logs in with an ID</Heading>
          <Text>Each participant must use a unique ID along with the Trial Code in order to access the trial. Usually this is an ID that you provide to them.</Text>
          {utils.canManageTrial(user, trial) &&
            <>
              <Button mt={3} as={RouterLink} to={`/trials/${trial._id}/settings`} size='sm' colorPalette='blue' variant='outline'>Manage joining settings</Button>
            </>}
        </Box>
      </Stack>
    </Stack>
  )
}
